import { useState } from "react"
import { useTranslation } from "react-i18next";
import './styles.scss';

enum LangEnum {
  es= "es",
  en= "en", 
};

export default function LanguageButton(){
  const [lang, setLang] = useState(LangEnum.en);
  const { i18n } = useTranslation()

  const handleOnClick = () => {
    if (lang === LangEnum.es) {
      setLang(LangEnum.en);
      i18n.changeLanguage(LangEnum.en)

    }
    if (lang === LangEnum.en) {
      setLang(LangEnum.es);
      i18n.changeLanguage(LangEnum.es)

    }
  }

  return (
    <button className="language-button" onClick={handleOnClick}> 📖 {lang === LangEnum.en ? 'Version en español' : 'English version'} 📖 </button>
  )
}